function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import Frame from "./Frame";
import { consumeContext as consumeEditorContext } from "../../EditorContext";
import { consumeContext as consumeOverlayContext } from "../../OverlayContext";
import Slider from "react-slick";

var Frames = function (_React$Component) {
  _inherits(Frames, _React$Component);

  function Frames() {
    var _temp, _this, _ret;

    _classCallCheck(this, Frames);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.selectFrame = function (frameId) {
      var frameSetter = function frameSetter() {
        return _this.props.EditorContext.frames.selectFrame(frameId);
      };

      _this.props.OverlayContext.rememberFrame(frameSetter);

      frameSetter();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Frames.prototype.renderFrames = function renderFrames() {
    var _this2 = this;

    var _props$EditorContext$ = this.props.EditorContext.frames.getFrames(),
        _props$EditorContext$2 = _props$EditorContext$.frames,
        framesList = _props$EditorContext$2 === undefined ? [] : _props$EditorContext$2,
        _props$EditorContext$3 = _props$EditorContext$.selectedFrame,
        selectedFrameId = _props$EditorContext$3 === undefined ? 0 : _props$EditorContext$3;

    var settings = {
      dots: false,
      infinite: false,
      touchMove: false,
      className: "center",
      speed: 500,
      slidesToShow: 14,
      slidesToScroll: 14,
      initialSlide: 0,
      beforeChange: function beforeChange(oldIndex, newIndex) {
        if (newIndex < oldIndex) {
          return;
        }

        if (framesList.length <= newIndex + 14) {
          _this2.props.EditorContext.frames.loadMoreFrames();
        }
      },
      responsive: [{
        breakpoint: 1600,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 10
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      }]
    };
    return React.createElement(Slider, settings, framesList.map(function (frame) {
      return React.createElement(Frame, {
        key: frame.id,
        frame: frame,
        isSelected: frame.id === selectedFrameId,
        selectFrame: _this2.selectFrame
      });
    }), framesList.length === 0 && React.createElement("div", {
      className: "recorder__gallery-item"
    }));
  };

  Frames.prototype.render = function render() {
    return React.createElement(React.Fragment, null, this.renderFrames());
  };

  return Frames;
}(React.Component);

Frames.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired,
  OverlayContext: PropTypes.object.isRequired
} : {};
export default consumeEditorContext(consumeOverlayContext(Frames));